import React, { useEffect, lazy, Suspense, useState } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import axios from "axios";
import PrivateRoute from "./utils/PrivateRoute";
import AuthRoute from "./utils/AuthRoute";
// Redux
import { useDispatch, connect, useSelector } from "react-redux";
import store from "./redux/store";
import { getCategories, getMenuItems } from "./redux/actions/menuActions";
import {
  SET_AUTHENTICATED,
  ADMIN_LOGIN,
  ADMIN_LOGOUT,
  CHANGE_THEME,
} from "./redux/types";

// Components
import setAuthToken from "./utils/setAuthToken";

// MUI
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  amber,
  blue,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from "@material-ui/core/colors";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import "./App.css";
import WrapMobile from "./Components/WrapMobile";

const token = localStorage.getItem("token");
if (token) {
  store.dispatch({
    type: SET_AUTHENTICATED,
  });
  axios.defaults.headers.common["auth-token"] = token;
  store.dispatch({
    type: ADMIN_LOGIN,
    payload: {
      token: token,
    },
  });
}

const Scanner = lazy(() => import("./Pages/Scanner"));
const Menu = lazy(() => import("./Pages/Menu.js"));
const AdminLoginPage = lazy(() => import("./Pages/AdminLoginPage"));
const AdminPage = lazy(() => import("./Pages/AdminPage"));
const MenuItemForm = lazy(() => import("./Components/Menu/MenuItemForm"));
const ReviewOrderPage = lazy(() => import("./Pages/ReviewOrderPage"));
const OrderConfirmationPage = lazy(() =>
  import("./Pages/OrderConfirmationPage")
);
const Home = lazy(() => import("./Pages/Home/Home.js"));
const PrivacyPolicy = lazy(() => import("./Pages/privacyPolicy.js"));

function App(props) {
  // Theme Code Start
  const [primaryColor, setPrimaryColor] = useState(blue);
  const [secondaryColor, setSecondaryColor] = useState(red);

  const getColor = (color) => {
    switch (color) {
      case "red":
        return red;
      case "pink":
        return pink;
      case "purple":
        return purple;
      case "deepPurple":
        return deepPurple;
      case "indigo":
        return indigo;
      case "blue":
        return blue;
      case "lightBlue":
        return lightBlue;
      case "cyan":
        return cyan;
      case "teal":
        return teal;
      case "green":
        return green;
      case "lightGreen":
        return lightGreen;
      case "lime":
        return lime;
      case "yellow":
        return yellow;
      case "amber":
        return amber;
      case "orange":
        return orange;
      case "deepOrange":
        return deepOrange;
      default:
        return false;
    }
  };

  useEffect(() => {
    axios
      .post("/seller/gettheme", { resID: props.admin.data.id })
      .then((res) => {
        const theme = res.data.data;
        dispatch({
          type: CHANGE_THEME,
          payload: {
            primaryColor: theme.primary,
            secondaryColor: theme.secondary,
          },
        });
      })
      .catch((err) => console.log(err.response));
  }, [props.admin.data.id]);

  const adminTheme = useSelector((state) => state.UI.theme);

  console.log(adminTheme);

  useEffect(() => {
    setPrimaryColor(adminTheme.primary);
    setSecondaryColor(adminTheme.secondary);

    // Old Theme
    // setPrimaryColor(getColor(adminTheme?.primary) || blue);
    // setSecondaryColor(getColor(adminTheme?.secondary) || red);
  }, [adminTheme]);

  const theme = createMuiTheme({
    palette: {
      // primary: {
      //   50: blue[50],
      //   100: blue[100],
      //   light: blue[300],
      //   main: primaryColor,
      //   dark: blue[700],
      //   contrastText: "#fff",
      // },
      // type: "dark",
      primary: {
        light: "#757ce8",
        main: adminTheme.primary,
        dark: "#002884",
        contrastText: "#fff",
      },
      secondary: {
        light: "#ff5252",
        main: adminTheme.secondary,
        dark: "#d50000",
        contrastText: "#fff",
      },
      // secondary: {
      //   light: red.A200,
      //   main: secondaryColor,
      //   dark: red.A700,
      //   contrastText: "#fff",
      // },
      success: {
        light: green[300],
        main: green[500],
        dark: green[700],
        contrastText: "rgba(0, 0, 0, 0.87)",
      },
      error: {
        light: red[300],
        main: red[500],
        dark: red[700],
        contrastText: "#fff",
      },
      grey: {
        50: grey["50"],
        100: grey["100"],
        200: grey["200"],
        300: grey["300"],
        400: grey["400"],
        500: grey["500"],
        600: grey["600"],
        700: grey["700"],
        800: grey["800"],
        900: grey["900"],
        A100: grey["A100"],
        A200: grey["A200"],
        A400: grey["A400"],
        A700: grey["A700"],
      },
      common: {
        black: "#000",
        white: "#fff",
      },
    },
    typography: {
      fontFamily: '"Quicksand", sans-serif',
      subtitle1: {
        fontFamily: "sans-serif",
      },
      h6: {
        textTransform: "capitalize",
      },
    },
    overrides: {
      MuiCircularProgress: {
        variant: "indeterminate",
      },
    },
  });

  // Theme Code finish

  const dispatch = useDispatch();
  const {
    getCategories,
    getMenuItems,
    admin: {
      data: { id },
    },
  } = props;
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      dispatch({
        type: ADMIN_LOGOUT,
      });
    } else {
      // decode jwt token
      setAuthToken(localStorage.getItem("token"));
      dispatch({
        type: ADMIN_LOGIN,
        payload: {
          token: localStorage.getItem("token"),
        },
      });
      getCategories();
      getMenuItems(id);
    }
  }, [getCategories, getMenuItems, id]);
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Suspense
          fallback={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              <CircularProgress color="primary" size={50} />
            </div>
          }
        >
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/privacy">
              <PrivacyPolicy />
            </Route>
            <Route exact path="/qr">
              <WrapMobile>
                <Scanner />
              </WrapMobile>
            </Route>
            <Route exact path="/menu">
              <WrapMobile>
                <Menu />
              </WrapMobile>
            </Route>
            <Route exact path="/menu/:resID_FromURL/:tableNum_FromURL">
              <WrapMobile>
                <Menu />
              </WrapMobile>
            </Route>
            {/* <Route path="/menu/:itemId">
              <MenuItemForm />
            </Route> */}
            <Route path="/review-order">
              <WrapMobile>
                <ReviewOrderPage />
              </WrapMobile>
            </Route>
            <Route path="/order-confirmation">
              <WrapMobile>
                <OrderConfirmationPage />
              </WrapMobile>
            </Route>
            <AuthRoute exact path="/admin">
              <AdminLoginPage />
            </AuthRoute>
            <PrivateRoute path="/admin/dashboard" component={AdminPage} />
          </Switch>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

App.propTypes = {
  admin: PropTypes.object.isRequired,
  getCategories: PropTypes.func.isRequired,
  getMenuItems: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  admin: state.auth.admin,
});

const mapActionToProps = {
  getCategories,
  getMenuItems,
};

export default connect(mapStateToProps, mapActionToProps)(App);
